import Cookies from 'universal-cookie';

const HAS_LOCAL_STORAGE = testLocalStorage();
const COOKIES = new Cookies();

function testLocalStorage() {
    const testKey = 'test-local-storage';
    try {
        localStorage.setItem(testKey, '1');
        localStorage.removeItem(testKey);
        return true;
    } catch (e) {
        return false;
    }
}

const get = (key: string): string | null => {
    if (HAS_LOCAL_STORAGE) {
        return localStorage.getItem(key);
    } else {
        return COOKIES.get(key) as string;
    }
};

const put = (key: string, val: string) => {
    if (HAS_LOCAL_STORAGE) {
        localStorage.setItem(key, val);
    } else {
        COOKIES.set(key, val, {path: '/'});
    }
};

const remove = (key: string) => {
    if (HAS_LOCAL_STORAGE) {
        localStorage.removeItem(key);
    } else {
        COOKIES.remove(key);
    }
};

function getObject<T>(key: string, _default: T): T {
    try {
        const result = get(key);
        if (result) {
            return JSON.parse(result);
        } else {
            return _default;
        }
    } catch (e) {
        return _default;
    }
}

function putObject<T>(key: string, value: T) {
    put(key, JSON.stringify(value));
}

export {get, put, remove, getObject, putObject};
